import { action } from "typesafe-actions";
import { IActionGetDistinctRecords } from "./distinctrecord.types";
import { ThunkAction } from "redux-thunk";
import { buildTableQueryString, IStoreState, ITableQueryParams } from "..";
import { AnyAction } from "redux";
// import { getSearchQuery } from "../common/helpers";
import { api } from "../../api/api";
import { IBom } from "../bom";
import { IDrawing } from "../drawing";
// import { IRouting } from "../routing";
import { showMessage } from "../messages/messagesActions";

export const FETCH_DISTINCT_RECORD_PROGRESS = "FETCH_DISTINCT_RECORD_PROGRESS";
export const FETCH_DISTINCT_RECORD_SUCCESS = "FETCH_DISTINCT_RECORD_SUCCESS";
export const FETCH_DISTINCT_RECORD_FAILED = "FETCH_DISTINCT_RECORD_FAILED";

export const fetchDistinctRecordProgress = () =>
  action(FETCH_DISTINCT_RECORD_PROGRESS);

export const fetchDistinctRecordSuccess = (
  data: IBom[] | IDrawing[],
  // | IRouting[]
  totalRecords: number,
) => action(FETCH_DISTINCT_RECORD_SUCCESS, { data, totalRecords });
export const fetchDistinctRecordFailed = () =>
  action(FETCH_DISTINCT_RECORD_FAILED);

export const fetchDistinctRecordAsync =
  (params: ITableQueryParams): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchDistinctRecordProgress());

      let queryString = buildTableQueryString(params);

      // if (params.project_uuid) {
      //   queryString += `&project_uuid=${params.project_uuid}`;
      // }
      // if (params.status && params.status !== "-1") {
      //   queryString += `&status=${params.status}`;
      // }
      // if (
      //   params.columns &&
      //   params.columns.length > 0 &&
      //   params.value &&
      //   params.value.length > 0
      // ) {
      //   queryString += `&columns=${params.columns}`;
      //   queryString += `&value=${encodeURIComponent(params.value)}`;
      // }
      // if (params.from_date) {
      //   queryString += `&from_date=${params.from_date}`;
      // }
      // if (params.to_date) {
      //   queryString += `&to_date=${params.to_date}`;
      // }

      // if (params.pageNo) {
      //   queryString += `&pageNo=${params.pageNo}`;
      // }
      // if (params.itemPerPage) {
      //   queryString += `&itemPerPage=${params.itemPerPage}`;
      // }

      const res = await api.get(`/general/get-distinct-records${queryString}`);
      const data: IBom[] | IDrawing[] =
        // | IRouting[]
        res.data.data || [];
      const totalRecords = res.data.totalRecords || 0;
      dispatch(fetchDistinctRecordSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchDistinctRecordFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch records",
          displayAs: "snackbar",
        }),
      );
    }
  };
